export default __webpack_public_path__ + "static/media/better-treatment.9bec8837.jpg";